import { Locale } from 'src/types'
import { TIME_IN_MS } from 'src/constants'

import {
  Comparator,
  Filters,
  ListSorts,
  SortStates,
} from 'src/pages/FuelTrackingHistory/types'

export const handleSortChange = (sortState: SortStates): Comparator => {
  switch (sortState) {
    case SortStates.BY_NEW:
      return (a, b) => {
        return (
          new Date(b.dateOfRefuel.seconds * TIME_IN_MS.SECOND).getTime() -
          new Date(a.dateOfRefuel.seconds * TIME_IN_MS.SECOND).getTime()
        )
      }
    case SortStates.BY_FUEL_QUANTITY:
      return (a, b) => b.fuelQuantity - a.fuelQuantity

    case SortStates.BY_PRICE_PER_LITER:
      return (a, b) => {
        const priceB = b.pricePerLiter
        const priceA = a.pricePerLiter

        return priceB - priceA
      }

    case SortStates.BY_ODOMETER:
      return (a, b) => {
        const odoB = b.odometer
        const odoA = a.odometer

        return odoB - odoA
      }

    case SortStates.BY_TOTAL_COST:
      return (a, b) => {
        const costB = b.totalCost
        const costA = a.totalCost

        return costB - costA
      }
    default:
      throw new Error(`Unhandled sort state: ${sortState}`)
  }
}

export const getListOfSortStates = (
  locale: Locale['trackFuel']['historyFuel'],
): ListSorts[] => {
  const { byFuelQuantity, byNew, byOdometer, byPricePerLiter, byTotalCost } =
    locale.sortStates

  return [
    {
      type: SortStates.BY_FUEL_QUANTITY,
      title: byFuelQuantity,
    },
    {
      type: SortStates.BY_PRICE_PER_LITER,
      title: byPricePerLiter,
    },
    {
      type: SortStates.BY_ODOMETER,
      title: byOdometer,
    },
    {
      type: SortStates.BY_TOTAL_COST,
      title: byTotalCost,
    },
    {
      type: SortStates.BY_NEW,
      title: byNew,
    },
  ]
}

export function getCountOfActiveFilters(filters: Filters): number {
  return (Object.keys(filters) as Array<keyof Filters>).reduce((acc, key) => {
    return acc + (filters[key] ? 1 : 0)
  }, 0)
}
